export const es_auction = {
    title: 'Aste',
    body: 'Crea una nuova tabella e gestisci con facilità gli immobili in <b>asta</b> ed individua quelli da stralciare.',
    button: 'Crea e Gestisci',
    label_insert_auction: 'Aste inserite',
    label_city: 'Città',
    label_region: 'Regione',
    label_address: 'Indirizzo',
    label_rge : 'RGE',
    label_ctu: 'CTU',
    label_mq: 'Mq',
    label_tender: 'n. Incanto',
    label_auction_base: 'Base asta',
    label_minimum_offer: 'Offerta minima',
    label_cadastral_income: 'Rendita catas.',
    label_auction_date: 'Data asta',
    label_city_planning: 'Regolarità Urb.',
    label_creditors: 'n. Creditori',
    label_occupancy_status: 'Stato occupazionale',
    label_building_value: 'V. immobiliare.it',
    label_borsino_value: 'V. borsino',
    label_street_price: 'Street price',
    label_agency_1: 'Agenzia 1',
    label_agency_2: 'Agenzia 2',
    label_agency_3: 'Agenzia 3',
    label_guardian: 'Riferimenti custode',
    label_note:'Note',
    label_excerpt: 'Stralciabile',
    label_title: 'Archivio',
    label_choose_color: 'Scegli un colore',
    table_label_address: 'Indirizzo',
    table_label_auction_base: 'Base asta',
    table_archive_title: 'Lista aste ',
    table_archive_label_excerpt: 'Stralcio',
    table_archive_label_address: 'Indirizzo',
    table_archive_label_auction_base: 'Base asta',
    table_archive_label_minimum_offer: 'Off. min.',
    table_archive_label_street_price: 'Street price',
    income_label_auction_buy: 'Acquisto in asta',
    income_label_tax: 'Tassa reg. 1a casa',
    income_delete: 'Cancell. ipot., pign.',
    income_building_evacuation: 'Sgombro, fabbro...',
    income_technical_studio: 'Studio tecnico',
    income_fix_tax: 'Tasse fisse',
    income_refactoring_job: 'Lavori ristrut.',
    income_new_users: 'Nuove utenze',
    income_unexpected: 'Imprevisti',
    income_ace: 'ACE',
    income_realestate_agency: 'Ag. immob.(2%)',
    income_home_staging: 'Home staging',
    income_condominium: 'Condominio',
    income_substitutive_tax: 'Imposta sost.',
    income_expert: 'Perito',
    income_insurance: 'Assicurazione',
    income_investigation: 'Istruttoria',
    income_broker: 'Broker',
    income_revenues: 'Ricavi',
    income_cost: 'Costi',
    income_profit: 'Utile',
    income_cash: 'Differenza contanti',
    income_roi: 'ROI',
    income_roe: 'ROE',
    income_concession_fee: 'Oneri concessori',

    popover_map_title: 'Scegli la regione',
    popover_map_content: '<p>Seleziona la regione nella quale intendi inserire le tue aste immobiliari.</p>',
    popover_list_title: 'Le tue aste',
    popover_list_content: '<p>In questa card puoi controllare le tue aste suddivise per colore. Ogni colore riassume ' +
        'l\'appetibilità dell\'asta. In questo modo avrai sempre sotto controllo quali aste prendere in considerazione. </p>' +
        '<p>Per inserire una nuova asta, utilizza il bottone sulla destra "Nuova asta".</p>' +
        '<p>Qui di seguito, invece, la legenda dei colori da utilizzare:</p>'+
        '<p><strong style="color:red">Rosso</strong><br>Prezzo base d\'asta o offerta minima superiore, uguale o poco inferiore al valore delle banche dati</p>' +
        '<p><strong style="color:#f0c330">Giallo</strong><br>Prezzo base d’asta o offerta minima inferiore del 40/50% rispetto al valore delle banche dati</p>' +
        '<p><strong style="color:green">Verde</strong><br>Prezzo base d\'asta o offerta minima inferiore di almeno 60/70% rispetto al valore delle banche dati</p>' +
        '<p><strong style="color:grey">Grigio</strong><br>Indipendentemente dal prezzo l\'immobile non ci interessa</p>' +
        '<p>Qualora decidessi di approfondire l’operazione puoi cliccare l’icona <i class="fas fa-calculator abtg__fontIcon" style="font-size:140%!important;"></i> per accedere alla scheda dell’operazione e al conto economico. </p>',

    popover_archive_title: 'Il tuo archivio',
    popover_archive_content:
        '<p>In questa card puoi selezionare e gestire le aste create in base alla regione selezionata sulla mappa.</p>\n',

    popover_first_archive_title: 'Il tuo archivio',
    popover_first_archive_content:
        '<p>In questa card sono presenti tutte le città da te selezionate nelle quali hai inserito almeno un\'asta.</p>\n',

    popover_legend_title: 'I colori',
    popover_legend_content:
        '<p><strong style="color:red">Rosso</strong><br>Prezzo base d\'asta o offerta minima superiore, uguale o poco inferiore al valore delle banche dati</p>' +
        '<p><strong style="color:#f0c330">Giallo</strong><br>Prezzo base d’asta o offerta minima inferiore del 40/50% rispetto al valore delle banche dati</p>' +
        '<p><strong style="color:green">Verde</strong><br>Prezzo base d\'asta o offerta minima inferiore di almeno 60/70% rispetto al valore delle banche dati</p>' +
        '<p><strong style="color:grey">Grigio</strong><br>Indipendentemente dal prezzo l\'immobile non ci interessa</p>',

    popover_auctionBuilding_title: 'I dati dell\'immobile',
    popover_auctionBuilding_content: '<p>In questa sezione puoi gestire la scheda della tua operazione, modificare i dati, personalizzare il tuo conto economico, inserire il team di lavoro che opera sull’operazione, allegare foto e documenti e compilare la card “To do List” per le azioni da svolgere.</p>\n',

    popover_resource_title: 'Recursos',
    popover_resource_content: '<p>In questa card puoi allegare i contenuti fotografici e tutta la documentazione utile allo svolgimento della tua operazione.</p>\n'

};